import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, Collapse } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const LogoErpFirmReportTableFilter = (props) => {
  const [form] = Form.useForm();

  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ ...firmSelect, loading: true });
      RequestHandler.get(
        `/ErpReport/GetLogoFirmReport?$select=FirmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )}`
      ).then((res) => {
        if (res) {
          setFirmSelect({ data: res, loading: false });
        }
      });
    } else {
      setFirmSelect({ ...firmSelect, data: [] });
    }
  };

  const onFinish = (values) => {
    let query = "";
    const conditions = [];

    if (values.id) {
      conditions.push(`name eq '${values.id}'`);
    }

    if (values.cariHesapKodu) {
      conditions.push(odata.contains("FirmBranchNumber", values.cariHesapKodu));
    }

    if(values.vkn) {
      conditions.push(odata.contains("Vkn", values.vkn));
    }

    if (conditions.length !== 0) {
      query = "&$filter=" + conditions.join(" and ");
    }
    if (props.onFinishFilter) props.onFinishFilter(query);
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="firmFilter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="id" label="Cari Adı :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      loading={firmSelect.loading}
                      onSearch={onFirmSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {firmSelect.data.map((item) => (
                        <Select.Option
                          key={item.cariHesapKodu}
                          value={item.cariHesapUnvani}
                        >
                          {item.cariHesapUnvani}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="cariHesapKodu" label="Cari Kodu :">
                    <Input />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="vkn" label="VKN :">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default LogoErpFirmReportTableFilter;
